const ROUTES = {
  "/": {
    "name": "HomePage437b53df9db04fed9ae68caf2083dfb9",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageDde291d57380429d92b3B71ca3a77964",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/local-partnership": {
    "name": "LocalPartnershipPage35ad53d55a8b4182Bf8b1374cacd5381",
    "type": "HTML",
    "key": "local-partnership-page"
  },
  "/apply/*": {
    "name": "ApplicationPages1b7e46245cf84c7cB1ab2ad4d5cdd502",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/contact": {
    "name": "PublicContactPage7580816dBf304a4fBb3227a7965a6491",
    "type": "HTML",
    "key": "public-contact-page"
  },
  "/events/public": {
    "name": "PublicEventsPageD3c1810eB29e4e97Bbb1Ebf98210ab3a",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/faq": {
    "name": "PublicFaqPageD1b033fc01824c699f633236d7c13e29",
    "type": "HTML",
    "key": "public-faq-page"
  },
  "/join": {
    "name": "JoinUsPage7a3d3681C0fe400dBec1360f5ac7a908",
    "type": "HTML",
    "key": "join-us-page"
  }
};

export default ROUTES;